export function decodeToken(token) {
    try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        if (payload.exp && Date.now() >= payload.exp * 1000) return null; // expiré
        return payload.user_id; // ou ce que tu stockes dedans
    } catch (err) {
        return null; // token invalide
    }
}